<template>
  <!-- 根据tableData的值去显示隐藏列表 -->
  <div style="height:100%">
    <div class="Main">
      <div class="topMain">
        <div slot="header" class="clearfix">
          <span>角色管理</span>
          <el-button v-if="multipleSelection.length == 0" style="float: right;" type="primary" @click="addBtn">创建
          </el-button>
          <div style="float: right;" v-if="multipleSelection.length != 0">
            <span>已选中<i class="checkedNumb"> {{ multipleSelection.length }}</i>
              个</span>
            <el-dropdown trigger="click" @command="operationBtn">
              <span class="el-dropdown-link">
                操作<i class="el-icon-arrow-down el-icon--right"></i>
              </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item :command="{ type: 'del', para: multipleSelection }">删除</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
        </div>
      </div>
      <div class="coreMain">
        <div>
          <el-input class="input-with-select" placeholder="搜索角色" v-model="search" @keyup.enter.native="searchBtn">
          </el-input>
          <el-button @click="searchBtn" icon="el-icon-search" type="primary"></el-button>
          <el-button class="clearSearch" type="text" @click="reset">清除搜索条件</el-button>
        </div>
        <el-table v-loading="loading" ref="multipleTable" :data="tableData" style="width: 100%"
          @selection-change="handleSelectionChange">
          <el-table-column type="selection" width="55"></el-table-column>
          <el-table-column prop="roleName" label="角色名称"></el-table-column>
          <el-table-column prop="createDate" label="创建时间">
            <template slot-scope="scope">
              <span>{{ changeDate(scope.row.createDate) }}</span>
            </template>
          </el-table-column>
          <el-table-column label="">
            <template slot-scope="scope">
              <el-dropdown class="briefDetails" style="top:22px;right:32px" @command="command">
                <span class="el-dropdown-link">
                  <i class="el-icon-more"></i>
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item :command="{
                      type: 'edit',
                      id: scope.row.id,
                      name: scope.row.roleName
                    }">编辑</el-dropdown-item>
                  <el-dropdown-item :command="{ type: 'del', id: scope.row.id }">删除</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage"
          :page-sizes="[10, 20, 50, 100]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper"
          :total="total">
        </el-pagination>
      </div>
    </div>
    <!-- 创建角色 -->
    <el-dialog title="新增角色" :visible.sync="dialogFormVisible" :show-close="false">
      <el-form :model="addForm" status-icon ref="addForm" :rules="addFormRules" :label-width="formLabelWidth">
        <el-form-item label="角色名称：" prop="roleName">
          <el-input style="width:70%" v-model="addForm.roleName" autocomplete="off" maxlength="100"></el-input>
        </el-form-item>
        <el-form-item label="角色权限：" prop="menuIds">
          <el-tree :data="addTreeData" ref="addTree" default-expand-all show-checkbox node-key="id" highlight-current
            @check-change="changeAddTree" :props="defaultProps">
          </el-tree>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="setUp('addForm')">确 定</el-button>
      </div>
    </el-dialog>
    <!-- 修改角色 -->
    <el-dialog title="修改角色" :show-close="false" :visible.sync="editdialogFormVisible">
      <el-form :model="editForm" status-icon ref="editForm" :rules="editFormRules" :label-width="formLabelWidth">
        <el-form-item label="角色名称：" prop="roleName">
          <el-input style="width:70%" v-model="editForm.roleName" autocomplete="off" maxlength="100"></el-input>
        </el-form-item>
        <el-form-item label="角色权限：" prop="menuIds">
          <el-tree :data="editTreeData" ref="editTree" default-expand-all :check-strictly="checkStrictly" show-checkbox
            node-key="id" :default-checked-keys="menuChecked" highlight-current @check-change="changeEditTree"
            :props="defaultProps">
          </el-tree>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="editdialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="editSetUp('editForm')">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
  import API from "../../api/api";
  import dayjs from "dayjs";
  export default {
    data() {
      return {
        total: 0,
        pageSize: 10,
        currentPage: 1,
        loading: false, //加载条
        search: "", //搜索
        tableData: [],
        addTreeData: [], //添加角色菜单树
        editTreeData: [], //编辑角色菜单树
        checkStrictly: false /*tree树父子节点关联*/,
        /*修改页面的树状列表默认选中*/
        menuChecked: [],
        defaultLabel: '',
        defaultProps: {
          children: "children",
          label: "menuName"
        },
        multipleSelection: [],
        formLabelWidth: "180px",
        //新增角色
        addForm: {
          roleName: ''
        },
        //编辑角色
        editForm: {
          roleName: ''
        },
        dialogFormVisible: false,
        editdialogFormVisible: false,
        addFormRules: {
          roleName: [{
            required: true,
            message: "请输入角色名称",
            trigger: "blur"
          }]
        },
        editFormRules: {
          roleName: [{
            required: true,
            message: "请输入角色名称",
            trigger: "blur"
          }]
        }
      };
    },
    created() { },
    methods: {
      //初始化时间
      changeDate(time) {
        return dayjs(new Date(time)).format("YYYY-MM-DD HH:mm:ss");
      },
      //获取列表数据
      getPage() {
        let para = {
          pageSize: this.pageSize,
          currentPage: this.currentPage,
          roleName: this.search
        };
        this.loading = true; /*显示加载条*/
        API.rolePage(para)
          .then(res => {
            if (res.code == 1) {
              this.tableData = res.data.resultPage;
              this.total = res.data.total;
            } else {
              this.$message.error(res.msg);
            }
            this.loading = false; /*显示加载条*/
          })

      },
      //搜索功能
      searchBtn() {
        (this.status = ""), //下拉选项为空
          this.getPage();
      },
      //清除搜索条件
      reset() {
        this.search = "";
        this.getPage();
      },
      //选择的数组
      handleSelectionChange(val) {
        this.multipleSelection = val;
      },
      //批量操作-删除
      operationBtn(val) {
        if (val.type == "del") {
          let arr = [];
          val.para.forEach(element => {
            arr.push(element.id);
          });
          let str = arr.join(",");
          this.delBtn(str);
        }
      },
      //单独删除功能
      command(val) {
        if (val.type == "del") {
          let str = val.id;
          this.delBtn(str);
        }
        if (val.type == "edit") {
          this.editdialogFormVisible = true;
          this.$nextTick(() => {
            this.$refs.editForm.resetFields()
          })
          let _this = this;
          let para = {
            roleId: val.id
          };
          this.loading = true; /*显示加载条*/
          this.checkStrictly = true; /** 将树的父级与子级关联移除 */
          API.sysRolePermissionSelectMenuId(para).then(res => {
            this.editForm = {
              roleName: val.name,
              roleId: val.id,
              menuIds: res.data
            };
            this.menuChecked = res.data;
            API.sysMenuPermissionList().then(res => {
              if (res.code == 1) {
                this.editTreeData = res.data;
                let _this = this
                for (let i = 0; i < _this.editTreeData.length; i++) {
                  if (_this.editTreeData[i].permissionCode != null && _this.editTreeData[i].permissionCode !=
                    '') {
                    _this.editTreeData[i].menuName = _this.editTreeData[i].permissionName
                  }
                  if (_this.editTreeData[i].children) {
                    for (let j = 0; j < _this.editTreeData[i].children.length; j++) {
                      if (_this.editTreeData[i].children[j].permissionCode != null && _this.editTreeData[i]
                        .children[j].permissionCode != '') {
                        _this.editTreeData[i].children[j].menuName = _this.editTreeData[i].children[j]
                          .permissionName
                      }
                      if (_this.editTreeData[i].children[j].children) {
                        for (let k = 0; k < _this.editTreeData[i].children[j].children.length; k++) {
                          if (_this.editTreeData[i].children[j].children[k].permissionCode != null && _this
                            .editTreeData[i].children[j].children[k].permissionCode != '') {
                            _this.editTreeData[i].children[j].children[k].menuName = _this.editTreeData[i]
                              .children[j].children[k].permissionName
                          }
                          if (_this.editTreeData[i].children[j].children[k].children) {
                            for (let p = 0; p < _this.editTreeData[i].children[j].children[k].children
                              .length; p++) {
                              if (_this.editTreeData[i].children[j].children[k].children[p].permissionCode !=
                                null && _this.editTreeData[i].children[j].children[k].children[p]
                                  .permissionCode != '') {
                                _this.editTreeData[i].children[j].children[k].children[p].menuName = _this
                                  .editTreeData[i].children[j].children[k].children[p].permissionName
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }
                this.checkStrictly = false; /** 将树的父级与子级关联绑定 */
              }
              this.loading = false; /*隐藏加载条*/
            });
          });
        }
      },

      //删除功能 单独批量公用
      delBtn(delID) {
        let para = {
          ids: delID
        };
        this.$confirm("此操作将永久删除数据, 是否继续?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        })
          .then(() => {
            API.delRole(para).then(res => {
              if (res.code == 1) {
                this.$message.success("删除成功");
                this.getPage();
              } else {
                this.$message.error(res.msg);
              }
            });
          })
          .catch(() => {
            this.$message({
              type: "info",
              message: "已取消删除"
            });
          });
      },
      //跳转到详情页
      detailBtn(id) {
        //  直接调用$router.push 实现携带参数的跳转
        // this.$router.push({
        //   path: "/device/moduleDetail",
        //   query: {
        //     id: id
        //   }
        // });
      },
      //弹出创建页
      addBtn() {
        this.dialogFormVisible = true;
        this.$nextTick(() => {
          this.$refs.addForm.resetFields()
        })
        API.sysMenuPermissionList().then(res => {
          if (res.code == 1) {
            this.addTreeData = res.data;
            let _this = this
            for (let i = 0; i < _this.addTreeData.length; i++) {
              if (_this.addTreeData[i].permissionCode != null && _this.addTreeData[i].permissionCode != '') {
                _this.addTreeData[i].menuName = _this.addTreeData[i].permissionName
              }
              if (_this.addTreeData[i].children) {
                for (let j = 0; j < _this.addTreeData[i].children.length; j++) {
                  if (_this.addTreeData[i].children[j].permissionCode != null && _this.addTreeData[i].children[j]
                    .permissionCode != '') {
                    _this.addTreeData[i].children[j].menuName = _this.addTreeData[i].children[j].permissionName
                  }
                  if (_this.addTreeData[i].children[j].children) {
                    for (let k = 0; k < _this.addTreeData[i].children[j].children.length; k++) {
                      if (_this.addTreeData[i].children[j].children[k].permissionCode != null && _this.addTreeData[
                        i].children[j].children[k].permissionCode != '') {
                        _this.addTreeData[i].children[j].children[k].menuName = _this.addTreeData[i].children[j]
                          .children[k].permissionName
                      }
                      if (_this.addTreeData[i].children[j].children[k].children) {
                        for (let p = 0; p < _this.addTreeData[i].children[j].children[k].children.length; p++) {
                          if (_this.addTreeData[i].children[j].children[k].children[p].permissionCode != null &&
                            _this.addTreeData[i].children[j].children[k].children[p].permissionCode != '') {
                            _this.addTreeData[i].children[j].children[k].children[p].menuName = _this.addTreeData[i]
                              .children[j].children[k].children[p].permissionName
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        });
      },
      //监听新增角色权限
      changeAddTree(val, checked) {
        let parentkey = this.$refs.addTree.getHalfCheckedKeys(true);
        let keys = this.$refs.addTree.getCheckedKeys();
        let arr = keys.concat(parentkey);
        this.addForm.menuIds = arr; //拿到所有的id 包含父节点子节点的
      },
      //监听修改角色权限
      changeEditTree(val, checked) {
        let parentkey = this.$refs.editTree.getHalfCheckedKeys(true);
        let keys = this.$refs.editTree.getCheckedKeys();
        let arr = keys.concat(parentkey);
        this.editForm.menuIds = arr;
      },
      //创建角色按钮
      setUp(formName) {
        let _this = this;
        let _API = API;
        this.$refs[formName].validate(valid => {
          if (valid) {
            _API.addSysRole(_this.addForm).then(res => {
              if (res.code == 1) {
                _this.$message({
                  message: "创建角色成功",
                  type: "success"
                });
                this.dialogFormVisible = false;
                this.getPage();
              } else {
                _this.$message({
                  message: res.msg,
                  type: "error"
                });
              }
            });
          } else {
            console.log("error submit!!");
            return false;
          }
        });
      },
      //修改角色
      editSetUp(formName) {
        let _this = this;
        let _API = API;
        this.$refs[formName].validate(valid => {
          if (valid) {
            _API.editSysRole(_this.editForm).then(res => {
              if (res.code == 1) {
                _this.$message({
                  message: "修改角色成功",
                  type: "success"
                });
                this.editdialogFormVisible = false;
                this.getPage();
              } else {
                _this.$message({
                  message: res.msg,
                  type: "error"
                });
              }
            });
          } else {
            console.log("error submit!!");
            return false;
          }
        });
      },
      //分页
      handleSizeChange(val) {
        this.pageSize = val;
        this.currentPage = 1;
        this.getPage();
      },
      handleCurrentChange(val) {
        this.currentPage = val;
        this.getPage();
      }
    },
    mounted() {
      this.getPage();
    }
  };

</script>


// WEBPACK FOOTER //
// src/views/platform/roleManagement.vue